import { useState } from 'react';
import { BellIcon } from '@phosphor-icons/react';

const NotifyMeButton = ({ onSetReminder, isReminderSet = false, className = '' }) => {
  const [isSettingReminder, setIsSettingReminder] = useState(false);
  const [reminderSet, setReminderSet] = useState(isReminderSet);

  const handleClick = async () => {
    if (reminderSet || isSettingReminder) return;

    setIsSettingReminder(true);
    try {
      await onSetReminder();
      setReminderSet(true);
    } catch (error) {
      // Parent handles errors
    } finally {
      setIsSettingReminder(false);
    }
  };

  return (
    <button
      onClick={handleClick}
      disabled={isSettingReminder || reminderSet}
      className={`
        flex items-center justify-center space-x-1
        h-[40px] p-2 flex-1
        rounded-full border border-[var(--q3-stroke-normal)]
        bg-[var(--q3-surface-default)]
        text-sm text-[var(--q3-neutral-default)]
        transition-colors disabled:opacity-60 ${reminderSet ? 'cursor-not-allowed' : 'cursor-pointer'}
        ${className}
      `}
    >
      {reminderSet ? (
        <>
          <BellIcon size={22} className="text-[var(--q3-neutral-default)]" />
          <span>You Will Be Notified</span>
        </>
      ) : (
        <>
          <BellIcon size={22} className="text-[var(--q3-neutral-default)]" />
          <span>{isSettingReminder ? 'Setting...' : 'Notify Me'}</span>
        </>
      )}
    </button>
  );
};

export default NotifyMeButton;
